export default __webpack_public_path__ + "media/images/landing-36-550x420-dcf18567841543aba043a29e180bffaa.jpg";